@if (reviews) {
  <div [id]="navLink.id" class="udex-grid udex-mx-auto">
    <div class="row justify-content-center">
      <div class="col-lg-9 mx-auto">
        <h2 class="text-center heading__regular--l pt-7 mb-6">
          {{ navLink.headline | cxTranslate: navLink.headlineParams }}
        </h2>
      </div>
    </div>
    @if (reviewTexts) {
      <div class="row justify-content-center align-content-center">
        @if (reviews.meta.record_count > 0) {
          <div>
            @if (reviewTexts?.sectionDescription) {
              <div class="col-12 mb-5 body--s--l text-center mx-auto">
                <p>{{ reviewTexts.sectionDescription }}</p>
              </div>
            }
          </div>
        }
        <div class="col-lg-9 mx-auto">
          @if (reviews.meta.record_count === 0) {
            <dcp-first-review
              [btnText]="reviewTexts?.ctaText"
              [g2Product]="reviews.meta.product"
              [infoText]="reviewTexts?.infoText"
              [pageCount]="pageCount"
              class="mb-6">
            </dcp-first-review>
          }
          @if (reviews.meta.record_count > 0) {
            <div>
              <span class="separator"></span>
              <dcp-review-summary
                [ctaText]="reviewTexts?.ctaText"
                [g2Meta]="reviews.meta"
                [infoText]="reviewTexts?.infoText"
                class="separator"></dcp-review-summary>
              <div class="mt-6">
                <h3 class="heading__regular--s mb-5 mb-md-3">{{ reviewTexts?.subSectionTitle }}</h3>
                <p class="mb-5 mb-md-3">
                  {{ 'productReview.reviewsCollectedAndHosted' | cxTranslate }}
                  <span
                    (click)="openRedirectToG2(reviews.meta.product.g2crowd_url)"
                    (keyup.enter)="openRedirectToG2(reviews.meta.product.g2crowd_url)"
                    [tabIndex]="0"
                    class="btn-link udex-cursor-pointer focusable focusable__element offset-none"
                    >{{ 'productReview.G2Com' | cxTranslate }}{{ 'common.dot' | cxTranslate }}</span
                  >
                </p>
                @for (review of reviews.data; track review) {
                  <div class="mt-5">
                    <dcp-review-preview
                      [limitedHtmlSiblings]="limitedTextComponents"
                      [reviewAnswerOrder]="reviewAnswerOrder"
                      [review]="review"
                      class="mt-5">
                    </dcp-review-preview>
                  </div>
                }
                <div class="mt-6">
                  @if (reviews.meta.page_count > 1) {
                    <dcp-pagination
                      (viewPageEvent)="pageChange($event)"
                      [pagination]="{currentPage: currentPage, totalPages: pageCount}">
                    </dcp-pagination>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="udex-legacy-shadow d-none d-lg-block udex-my-32"></div>
}
